<div *ngIf="savedSearchesPageLink?.length" class="pcg-saved-search">
    <div class="pcg-saved-search__item">
        <ng-container *ngIf="savedSearchesService.isSearchSaved$ | async as is">
            <button (click)="toggleForm($event)" *ngIf="!is.saved" class="pcg-secondary-button pcg-saved-search__save pcg-contrast__btn">Save this search</button>
            <button (click)="toggleForm($event)" *ngIf="is.saved" class="pcg-secondary-button pcg-saved-search__save pcg-contrast__btn">Saved search</button>
        </ng-container>

        <div [ngClass]="{ 'show': showForm }" class="pcg-search-popover pcg-contrast-search-popover pcg-saved-search__popover">
            <h2 class="pcg-search-popover__title">Search</h2>
            <div class="pcg-search-popover__wrapper">
                <label class="pcg-search-popover__label" for="search-name">Search title</label>
                <input [(ngModel)]="formValue.name" class="pcg-search-popover__input" id="search-name" placeholder="Give you search a name" type="text">
            </div>
            <div class="pcg-search-popover__wrapper">
                <label class="pcg-search-popover__label" for="search-description">Search description</label>
                <textarea [(ngModel)]="formValue.description" class="pcg-search-popover__input" cols="30" id="search-description" placeholder="Give your search a description"
                          rows="3"></textarea>
            </div>
            <div class="pcg-search-popover__actions">
                <button (click)="save($event)" class="pcg-search-popover__button pcg-main-button">Save</button>
                <button (click)="delete($event)" *ngIf="!!formValue.id" class="pcg-search-popover__button pcg-secondary-button">Remove</button>
            </div>
        </div>

    </div>
    <a [link]="savedSearchesPageLink" class="pcg-secondary-button pcg-contrast__btn" pcg-ng-umbraco-link></a>
</div>
